import { Box, Stack, useTheme } from "@mui/material";

const AboutTeamPhoto = () => {
    const theme = useTheme();

    return (
        <>
            <Box
                className=""
                sx={{
                    backgroundColor: theme.palette.background.paper
                }}
            >
                <Stack
                    direction='row'
                    className="bodySideMargin1 sectionRadius"
                    sx={{
                        backgroundColor: 'transparent'
                    }}
                >
                    <Box
                        sx={{
                            width: '100%'
                        }}
                    >
                        <img 
                            src="/images/about/team.png" 
                            alt="Team" 
                            width='100%'
                            className="sectionRadius"
                        />
                    </Box>
                </Stack>
            </Box>
        </>
    );
}

export default AboutTeamPhoto;